"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/Sidebar/List/SearchBar.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _types = require('web/screens/Directory/types');
var _icons = require('web/screens/Search/Refined/icons');







const placeholders = {
  [_types.DirectoryTab.COWORKERS]: 'Search coworkers',
  [_types.DirectoryTab.PATIENTS]: 'Search patients',
  [_types.DirectoryTab.TEAMS]: 'Search teams',
}

/* The inbox's search pill, as a real field: it filters the list below. */
const SearchBar = ({ value, onChange, selectedTab }) => {
  const handleChange = _react.useCallback.call(void 0, 
    (e) => onChange(e.target.value),
    [onChange],
  )
  const onClear = _react.useCallback.call(void 0, () => onChange(''), [onChange])

  return (
    _react2.default.createElement('div', { className: "inbox-list--search-row", __self: this, __source: {fileName: _jsxFileName, lineNumber: 27}}
      , _react2.default.createElement('label', { className: "inbox-list--search directory-list--search" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 28}}
        , _react2.default.createElement(_icons.SearchIcon, { size: 18, __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}} )
        , _react2.default.createElement('input', {
          type: "text",
          placeholder: placeholders[selectedTab],
          'aria-label': placeholders[selectedTab],
          value: value,
          onChange: handleChange, __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}
        )
        ,  value && (
          _react2.default.createElement('button', {
            type: "button",
            className: "directory-list--search-clear",
            'aria-label': "Clear search" ,
            onClick: onClear, __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}

            , _react2.default.createElement(_icons.CloseIcon, { size: 14, __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}} )
          )
        )
      )
    )
  )
}

exports. default = SearchBar
